import {
    BET_HISTORY_PAGE_LENGTH,
} from '../../BetHistory/components/betHistory.constants';

function calculateOddsField(odds, numerator, denominator) {
    return odds === 'SP' ?
        'SP' :
        `${numerator}/${denominator}`
}

function calculateEachWayTermsField(eachWay, places, numerator, denominator) {
    return eachWay ?
        `${places} places ${numerator}/${denominator} odds` :
        null;
}

export function formatBetHistoryBets(bets) {
    const formatedBets = bets.map((bet, index) => {
        const { attributes } = bet;
        const selections = attributes.selections.map(selection => ({
            selectionName: selection.selection_name,
            odd: calculateOddsField(
                selection.odds_decimal,
                selection.odds_fractional_numerator,
                selection.odds_fractional_denominator,
            ),
            eachWay: selection.each_way,
            eachWayTerms: calculateEachWayTermsField(
                selection.each_way,
                selection.each_way_terms_places,
                selection.each_way_terms_numerator,
                selection.each_way_terms_denominator,
            ),
            eventDateTime: selection.event_datetime,
            eventName: selection.event_name,
        }));
        return {
            timeBetPlaced: attributes.bet_datetime,
            receiptId: bet.id,
            betType: attributes.bet_type,
            stake: attributes.bet_stake,
            totalStake: attributes.bet_total_stake,
            returns: attributes.returns,
            finished: attributes.bet_settled,
            win: attributes.win,
            estimatedReturns: attributes.estimated_returns,
            selections,
            page: Math.floor(index / BET_HISTORY_PAGE_LENGTH) + 1,
        };
    });

    return formatedBets;
}

export function formatBetHistoryErrors(errors) {
    const formatedErrors = {};

    errors.forEach((error) => {
        formatedErrors[error.code] = { message: error.detail };
    });

    return formatedErrors;
}



// WEBPACK FOOTER //
// /src/js/common/utils/formatBetHistory.js